import React, {useState, useContext} from "react";
import img1 from "./assets/image-1.png";
import img2 from "./assets/image-2.png";
import img3 from "./assets/image-3.png";
import img4 from "./assets/image-4.png";
import img5 from "./assets/image-5.png";
import img6 from "./assets/image-6.png";
import img7 from "./assets/image-7.png";
import img8 from "./assets/image-8.png";
const data = [
  {
    img: img1,
    title: "Metamask",
  },
  {
    img: img2,
    title: "WalletConnect",
  },
  {
    img: img3,
    title: "Trust Wallet",
  },
  {
    img: img4,
    title: "MathWallet",
  },
  {
    img: img5,
    title: "TokenPocket",
  },
  {
    img: img6,
    title: "Binance Chain",
  },
  {
    img: img7,
    title: "SafePal",
  },
];
const ConnectPopup = ({ setOpen }) => {
  const handleClick = (value) => {
    setOpen(false);
  };
  return (
    <>
      <div className="absolute z-20 top-[50px] right-0 bg-custom-gradient rounded-[10px] w-[300px] md:w-[361px]">
        <h2 className="pt-[18px] pl-[24px] text-res-xs text-main-black font-extrabold mb-[17px]">
          Select a wallet to connect
        </h2>
        <div className="flex flex-col gap-[4px] md:gap-[17px] px-[18px] pb-[29px]">
          {data.map((single, i) => (
            <button
              onClick={() => handleClick(single.title)}
              key={i}
              className="bg-main-black pl-[24px] pr-[18px] w-full h-[45px] flex justify-between items-center rounded-[5px]"
            >
              <h2 className="font-extrabold text-res-xs">{single.title}</h2>
              <img src={single.img} alt="" />
            </button>
          ))}
        </div>
      </div>
      <div
        className="fixed top-0 right-0 bottom-0 left-0 z-10"
        onClick={() => setOpen(false)}
      ></div>
    </>
  );
};

export default ConnectPopup;
